import { motion } from 'framer-motion'
import { ServerCrash, Home, TerminalSquare } from 'lucide-react'

export default function ClosedRoomScreen({ onBack }) {
  return (
    <div className="min-h-screen w-full flex items-center justify-center px-6 bg-[#050505] overflow-hidden relative">
      
      {/* 1. CINEMATIC BACKGROUND EFFECT (Matches Landing Page) */}
      <div className="absolute inset-0 z-0 opacity-40">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_rgba(239,68,68,0.1)_0%,_transparent_60%)]" />
        <div 
          className="absolute inset-0 opacity-[0.1]" 
          style={{ backgroundImage: `linear-gradient(#222 1px, transparent 1px), linear-gradient(90deg, #222 1px, transparent 1px)`, backgroundSize: '30px 30px' }} 
        />
      </div>

      {/* 2. THE MAIN FEEDBACK CONTAINER */}
      <motion.div 
        initial={{ opacity: 0, scale: 0.9, y: 10 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        className="relative z-10 max-w-sm w-full text-center"
      >
        
        {/* Large "System Alert" Icon */}
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: [0, 1, 0.5, 1] }} // Glitch animation
          transition={{ duration: 1, delay: 0.2 }}
          className="relative inline-flex items-center justify-center mb-10 group"
        >
          <div className="absolute inset-0 bg-red-600 blur-[60px] opacity-20 group-hover:opacity-40 transition-opacity" />
          <div className="relative bg-zinc-950 border border-white/5 p-6 rounded-3xl shadow-2xl rotate-3 group-hover:rotate-0 transition-transform duration-500">
             <ServerCrash className="w-16 h-16 text-red-500" />
          </div>
        </motion.div>
        
        {/* Massive Status Label */}
        <h2 className="text-6xl font-black italic tracking-tighter uppercase mb-2">
          GAME<br /><span className="text-red-600">ADJOURNED</span>
        </h2>

        <div className="inline-flex items-center gap-2.5 px-3 py-1.5 rounded-md border border-red-500/20 bg-red-500/5 mb-6 text-red-500 font-mono text-[10px] font-black uppercase tracking-[0.2em]">
          <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" />
          Host Resigned_
        </div>

        <p className="text-zinc-500 text-sm leading-relaxed mb-12 italic max-w-[280px] mx-auto">
          "The host has left the board. This match has been closed."
        </p>

        {/* Action Button */}
        <motion.button 
          onClick={onBack} 
          className="group relative w-full overflow-hidden rounded-xl bg-orange-600 px-8 py-5 transition-all hover:bg-orange-500 active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 focus:ring-offset-black"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          {/* Glitch Shine Effect (Matches Primary Button) */}
          <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/10 to-transparent group-hover:translate-x-full transition-transform duration-700 ease-in-out" />
          
          <span className="relative z-10 flex items-center justify-center gap-3 text-white font-black uppercase italic tracking-tight text-lg">
            <Home size={20} className="group-hover:rotate-6 transition-transform"/>
            Return to Lobby
          </span>
        </motion.button>

        {/* Minimalist Footer Decor */}
        <div className="mt-16 flex items-center justify-center gap-2 opacity-10">
          {[1, 2, 3, 4].map(i => (
             <div key={i} className="w-6 h-[1px] bg-white" />
          ))}
          <TerminalSquare size={12} className="text-white"/>
          {[1, 2, 3, 4].map(i => (
             <div key={i} className="w-6 h-[1px] bg-white" />
          ))}
        </div>
      </motion.div>
    </div>
  )
}